import {OrdersPerPaymentModeChartAllDto, OrdersPerPaymentModeChartDto} from "../../domain";
import {JObject} from "../../../../common/data/models";

export const OrdersPerPaymentModeChartMapper = {

    fromJson(json?: Array<JObject>): OrdersPerPaymentModeChartAllDto {
        
      var colors = [["#FFA726","#42A5F5"],["#c41f46","#85293f"],["#a31d1d", "#ed5a5a"],["#f56f42","#edddd8"],
    ["#9c8983","#5e2412"],["#2295c7","#3b677a"],["#6b1a62","#bf5cb4"],["#360730","#6e586b"]];
        if (!json){
            return {
                label: [],
                values: []
            }
        }
        var finalResult: OrdersPerPaymentModeChartAllDto = {
            label: [],
            values: []
        };
        finalResult.label = json.map(e => {
            return e.label
        });
        var ci =0;
        finalResult.label =  finalResult.label.filter((item, index) => finalResult.label.indexOf(item) === index);
        const result = json.reduce((acc, item) => {
            const graphName = item.label2;
            if (!acc[graphName]) {
              acc[graphName] = [];
            }
            acc[graphName].push(item);
            return acc;
          }, {});
          console.log("result",result);
        for (const [objectKey, objectValue] of Object.entries(result)) {
            var newObjectValue = [];
            for(var i =0; i<finalResult.label.length; i++){
                var checkExits = objectValue.filter((x:JObject)=>x.label === finalResult.label.at(i));
                if(checkExits.length>0){
                    newObjectValue.push({
                        value: checkExits.at(0).value,
                        value2: checkExits.at(0).value2,
                    })
                }
                else{
                    newObjectValue.push({
                        value: 0,
                        value2: 0
                    })
                }
            }
            console.log("objectKey",objectKey,colors.at(ci)?.at(0)!,colors.at(ci)?.at(1)!,i);
            finalResult.values.push(
                {
                    count: {
                        name: objectKey,
                        color: colors.at(ci)?.at(0)!,//'#FFA726',
                        value: newObjectValue.map((e:JObject) => {
                            return {
                                value: e.value,
                            }
                        }),
                    },
                    amount: {
                        name: objectKey,
                        color: colors.at(ci)!.at(1)!,//'#42A5F5',
                        value: newObjectValue.map((e:JObject) => {
                            return {
                                value: e.value2,
                            }
                        }),
                    },
                }
            );
            ci+=1;
    };
    return finalResult;
}
}
